import i18n from 'i18next'
import { initReactI18next, useTranslation } from 'react-i18next'
import arAccounting from '../locales/ar/accounting.json'
import arAdmin from '../locales/ar/admin.json'
import arAi from '../locales/ar/ai.json'
import arApprovals from '../locales/ar/approvals.json'
import arAudit from '../locales/ar/audit.json'
import arAuth from '../locales/ar/auth.json'
import arBank from '../locales/ar/bank.json'
import arBooksHealth from '../locales/ar/booksHealth.json'
import arCatalog from '../locales/ar/catalog.json'
import arCheques from '../locales/ar/cheques.json'
import arCommissions from '../locales/ar/commissions.json'
import arCommon from '../locales/ar/common.json'
import arContractBilling from '../locales/ar/contractBilling.json'
import arContracts from '../locales/ar/contracts.json'
import arCostObjects from '../locales/ar/costObjects.json'
import arCustomers from '../locales/ar/customers.json'
import arFiles from '../locales/ar/files.json'
import arFinance from '../locales/ar/finance.json'
import arHr from '../locales/ar/hr.json'
import arInventory from '../locales/ar/inventory.json'
import arLoyalty from '../locales/ar/loyalty.json'
import arNotifications from '../locales/ar/notifications.json'
import arOrgUnits from '../locales/ar/orgUnits.json'
import arPayroll from '../locales/ar/payroll.json'
import arPlatform from '../locales/ar/platform.json'
import arPos from '../locales/ar/pos.json'
import arPrivacy from '../locales/ar/privacy.json'
import arProjectBilling from '../locales/ar/projectBilling.json'
import arProjectBonds from '../locales/ar/projectBonds.json'
import arProjectClaims from '../locales/ar/projectClaims.json'
import arProjectContract from '../locales/ar/projectContract.json'
import arProjectInsights from '../locales/ar/projectInsights.json'
import arProjectRates from '../locales/ar/projectRates.json'
import arProjectReports from '../locales/ar/projectReports.json'
import arProjects from '../locales/ar/projects.json'
import arProjectTime from '../locales/ar/projectTime.json'
import arPurchasing from '../locales/ar/purchasing.json'
import arRefunds from '../locales/ar/refunds.json'
import arReports from '../locales/ar/reports.json'
import arSales from '../locales/ar/sales.json'
import arService from '../locales/ar/service.json'
import arServiceAssets from '../locales/ar/serviceAssets.json'
import arServiceDocs from '../locales/ar/serviceDocs.json'
import arServiceJobs from '../locales/ar/serviceJobs.json'
import arServiceOps from '../locales/ar/serviceOps.json'
import arServiceSites from '../locales/ar/serviceSites.json'
import arServiceVisit from '../locales/ar/serviceVisit.json'
import arSettings from '../locales/ar/settings.json'
import arShell from '../locales/ar/shell.json'
import arSuppliers from '../locales/ar/suppliers.json'
import arTasks from '../locales/ar/tasks.json'
import arTeams from '../locales/ar/teams.json'
import arWorkflows from '../locales/ar/workflows.json'
import enAccounting from '../locales/en/accounting.json'
import enAdmin from '../locales/en/admin.json'
import enAi from '../locales/en/ai.json'
import enApprovals from '../locales/en/approvals.json'
import enAudit from '../locales/en/audit.json'
import enAuth from '../locales/en/auth.json'
import enBank from '../locales/en/bank.json'
import enBooksHealth from '../locales/en/booksHealth.json'
import enCatalog from '../locales/en/catalog.json'
import enCheques from '../locales/en/cheques.json'
import enCommissions from '../locales/en/commissions.json'
import enCommon from '../locales/en/common.json'
import enContractBilling from '../locales/en/contractBilling.json'
import enContracts from '../locales/en/contracts.json'
import enCostObjects from '../locales/en/costObjects.json'
import enCustomers from '../locales/en/customers.json'
import enFiles from '../locales/en/files.json'
import enFinance from '../locales/en/finance.json'
import enHr from '../locales/en/hr.json'
import enInventory from '../locales/en/inventory.json'
import enLoyalty from '../locales/en/loyalty.json'
import enNotifications from '../locales/en/notifications.json'
import enOrgUnits from '../locales/en/orgUnits.json'
import enPayroll from '../locales/en/payroll.json'
import enPlatform from '../locales/en/platform.json'
import enPos from '../locales/en/pos.json'
import enPrivacy from '../locales/en/privacy.json'
import enProjectBilling from '../locales/en/projectBilling.json'
import enProjectBonds from '../locales/en/projectBonds.json'
import enProjectClaims from '../locales/en/projectClaims.json'
import enProjectContract from '../locales/en/projectContract.json'
import enProjectInsights from '../locales/en/projectInsights.json'
import enProjectRates from '../locales/en/projectRates.json'
import enProjectReports from '../locales/en/projectReports.json'
import enProjects from '../locales/en/projects.json'
import enProjectTime from '../locales/en/projectTime.json'
import enPurchasing from '../locales/en/purchasing.json'
import enRefunds from '../locales/en/refunds.json'
import enReports from '../locales/en/reports.json'
import enSales from '../locales/en/sales.json'
import enService from '../locales/en/service.json'
import enServiceAssets from '../locales/en/serviceAssets.json'
import enServiceDocs from '../locales/en/serviceDocs.json'
import enServiceJobs from '../locales/en/serviceJobs.json'
import enServiceOps from '../locales/en/serviceOps.json'
import enServiceSites from '../locales/en/serviceSites.json'
import enServiceVisit from '../locales/en/serviceVisit.json'
import enSettings from '../locales/en/settings.json'
import enShell from '../locales/en/shell.json'
import enSuppliers from '../locales/en/suppliers.json'
import enTasks from '../locales/en/tasks.json'
import enTeams from '../locales/en/teams.json'
import enWorkflows from '../locales/en/workflows.json'
import type { Language } from './format'
import { enumPreference } from './preferences'

export type { Language } from './format'

export const LANGUAGES = ['en', 'ar'] as const satisfies readonly Language[]
export const NAMESPACES = [
  'common',
  'auth',
  'shell',
  'customers',
  'suppliers',
  'accounting',
  'finance',
  'admin',
  'sales',
  'catalog',
  'inventory',
  'reports',
  'settings',
  'purchasing',
  'refunds',
  'cheques',
  'pos',
  'audit',
  'bank',
  'booksHealth',
  'files',
  'approvals',
  'workflows',
  'platform',
  'tasks',
  'teams',
  'service',
  'serviceJobs',
  'serviceVisit',
  'serviceOps',
  'serviceDocs',
  'serviceSites',
  'serviceAssets',
  'notifications',
  'orgUnits',
  'privacy',
  'projects',
  'costObjects',
  'projectInsights',
  'projectBilling',
  'projectClaims',
  'projectContract',
  'projectBonds',
  'projectTime',
  'projectRates',
  'projectReports',
  'ai',
  'loyalty',
  'contracts',
  'contractBilling',
  'hr',
  'payroll',
  'commissions',
] as const

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    shell: enShell,
    customers: enCustomers,
    suppliers: enSuppliers,
    accounting: enAccounting,
    finance: enFinance,
    admin: enAdmin,
    sales: enSales,
    catalog: enCatalog,
    inventory: enInventory,
    reports: enReports,
    settings: enSettings,
    purchasing: enPurchasing,
    refunds: enRefunds,
    cheques: enCheques,
    pos: enPos,
    audit: enAudit,
    bank: enBank,
    booksHealth: enBooksHealth,
    files: enFiles,
    approvals: enApprovals,
    workflows: enWorkflows,
    platform: enPlatform,
    tasks: enTasks,
    teams: enTeams,
    service: enService,
    serviceJobs: enServiceJobs,
    serviceVisit: enServiceVisit,
    serviceOps: enServiceOps,
    serviceDocs: enServiceDocs,
    serviceSites: enServiceSites,
    serviceAssets: enServiceAssets,
    notifications: enNotifications,
    orgUnits: enOrgUnits,
    privacy: enPrivacy,
    projects: enProjects,
    costObjects: enCostObjects,
    projectInsights: enProjectInsights,
    projectBilling: enProjectBilling,
    projectClaims: enProjectClaims,
    projectContract: enProjectContract,
    projectBonds: enProjectBonds,
    projectRates: enProjectRates,
    projectReports: enProjectReports,
    ai: enAi,
    projectTime: enProjectTime,
    loyalty: enLoyalty,
    contracts: enContracts,
    contractBilling: enContractBilling,
    hr: enHr,
    payroll: enPayroll,
    commissions: enCommissions,
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    shell: arShell,
    customers: arCustomers,
    suppliers: arSuppliers,
    accounting: arAccounting,
    finance: arFinance,
    admin: arAdmin,
    sales: arSales,
    catalog: arCatalog,
    inventory: arInventory,
    reports: arReports,
    settings: arSettings,
    purchasing: arPurchasing,
    refunds: arRefunds,
    cheques: arCheques,
    pos: arPos,
    audit: arAudit,
    bank: arBank,
    booksHealth: arBooksHealth,
    files: arFiles,
    approvals: arApprovals,
    workflows: arWorkflows,
    platform: arPlatform,
    tasks: arTasks,
    teams: arTeams,
    service: arService,
    serviceJobs: arServiceJobs,
    serviceVisit: arServiceVisit,
    serviceOps: arServiceOps,
    serviceDocs: arServiceDocs,
    serviceSites: arServiceSites,
    serviceAssets: arServiceAssets,
    notifications: arNotifications,
    orgUnits: arOrgUnits,
    privacy: arPrivacy,
    projects: arProjects,
    costObjects: arCostObjects,
    projectInsights: arProjectInsights,
    projectBilling: arProjectBilling,
    projectClaims: arProjectClaims,
    projectContract: arProjectContract,
    projectBonds: arProjectBonds,
    projectRates: arProjectRates,
    projectReports: arProjectReports,
    ai: arAi,
    projectTime: arProjectTime,
    loyalty: arLoyalty,
    contracts: arContracts,
    contractBilling: arContractBilling,
    hr: arHr,
    payroll: arPayroll,
    commissions: arCommissions,
  },
} as const

export function detectLanguage(): Language {
  const preferred = typeof navigator === 'undefined' ? [] : (navigator.languages ?? [navigator.language])
  return preferred.some((l) => l?.toLowerCase().startsWith('ar')) ? 'ar' : 'en'
}

export const languagePreference = enumPreference<Language>('lang', LANGUAGES, detectLanguage())

export function directionOf(language: Language): 'ltr' | 'rtl' {
  return language === 'ar' ? 'rtl' : 'ltr'
}

export function applyDocumentLanguage(language: Language): void {
  const root = document.documentElement
  root.lang = language
  root.dir = directionOf(language)
}

export function toLanguage(value: string | undefined): Language {
  return value === 'ar' ? 'ar' : 'en'
}

let initialised = false

export function initI18n(language: Language = languagePreference.get()): typeof i18n {
  if (initialised) return i18n
  initialised = true
  void i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: 'en',
    supportedLngs: [...LANGUAGES],
    ns: [...NAMESPACES],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    returnNull: false,
    initAsync: false,
  })
  applyDocumentLanguage(language)
  i18n.on('languageChanged', (lng) => applyDocumentLanguage(toLanguage(lng)))
  return i18n
}

/** Persists the choice and switches the whole UI (text, `lang`, `dir`). */
export function setLanguage(language: Language): void {
  languagePreference.set(language)
  void i18n.changeLanguage(language)
}

/** Only adopt the account's language when this browser has no explicit choice yet. */
export function adoptAccountLanguage(language: Language): void {
  if (languagePreference.isSet()) return
  void i18n.changeLanguage(language)
}

export function useLanguage(): { language: Language; dir: 'ltr' | 'rtl' } {
  const { i18n: instance } = useTranslation()
  const language = toLanguage(instance.resolvedLanguage ?? instance.language)
  return { language, dir: directionOf(language) }
}

export { i18n }
